<div class="theme-main-menu sticky-menu theme-menu-five" [ngClass]="headerSticky ? 'fixed' : ''">
  <div class="d-flex align-items-center justify-content-center">
    <div class="logo"><a [routerLink]="['/']"><img src="assets/images/logo/deski_06.svg" alt=""></a></div>

    <nav id="mega-menu-holder" class="navbar navbar-expand-lg">
      <div class="nav-container">
        <button class="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar"
          [ngClass]="menuActive ? 'navbar-toggler open' : 'navbar-toggler'" (click)="handleNavToggle()">
          <span></span>
        </button>
        <div class="navbar-collapse collapse" id="collapsibleNavbar">
          <div class="d-lg-flex justify-content-between align-items-center">
            <ul class="navbar-nav main-side-nav font-gordita" data-bs-toggle="collapse"
              data-bs-target="#collapsibleNavbar" id="one-page-nav">
              <li class="nav-item dropdown position-static">
                <a class="nav-link dropdown-toggle" [routerLink]="['./']" data-bs-toggle="dropdown">Home</a>
                <div class="dropdown-menu">
                  <!-- nav menu start -->
                  <app-mega-menu></app-mega-menu>
                </div> <!-- /.dropdown-menu -->
              </li>
              <li class="nav-item">
                <a [routerLink]="['./']" fragment="product" class="nav-link" (click)="handleNavToggle()">Product</a>
              </li>
              <li class="nav-item">
                <a [routerLink]="['./']" fragment="feature" class="nav-link" (click)="handleNavToggle()">Features</a>
              </li>
              <li class="nav-item">
                <a [routerLink]="['./']" fragment="pricing" class="nav-link" (click)="handleNavToggle()">Pricing</a>
              </li>
              <li class="nav-item">
                <a [routerLink]="['./']" fragment="feedback" class="nav-link" (click)="handleNavToggle()">Feedback</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
    <div class="right-widget">
      <ul class="d-flex align-items-center">
        <li>
          <a [routerLink]="['/login']" class="signIn-action d-flex align-items-center">
            <img src="assets/images/icon/52.svg" alt="">
            <span>login</span>
          </a>
        </li>
        <li>
          <div class="dropdown download-btn">
            <button class="dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              Download
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item d-flex align-items-center" [routerLink]="['./']">
                <img src="assets/images/icon/103.svg" alt="">
                <span>IOS & Android</span>
              </a>
              <a class="dropdown-item d-flex align-items-center" [routerLink]="['./']">
                <img src="assets/images/icon/104.svg" alt="">
                <span>Mac & Windows</span>
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>